export default __webpack_public_path__ + "static/resonant-link-quote-banner-79d03e178a3c87a0148f3accc298b990.png";